/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import {
  accessAPI,
  Boton,
  Titulo,
  CampoInformacion,
  Formulario
} from "../../../../shared";

import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Sidebar } from "../../../../shared";

export default function TarjetaAsignarTemplate({
  certificadoTipoId,
  TemplateDocumento,
  TemplateEtiqueta,
  TemplateEtiquetaDetalles
}) {
  const [template, setTemplate] = useState(TemplateDocumento);
  const [templateEtiqueta, setTemplateEtiqueta] = useState(TemplateEtiqueta);
  const [templateEtiquetaDetalles, setTemplateEtiquetaDetalles] = useState(TemplateEtiquetaDetalles);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const toast = useRef(null);

  function abrirSidebar() {
    setFormKey((k) => k + 1);
    setSidebarVisible(true);
  }

  function guardarTemplates(datosFormulario) {
    setLoader(true);
    accessAPI(
      "PUT",
      `admin/config/certificadotipo/templates/${certificadoTipoId}`,
      datosFormulario,
      (respuesta) => {
        setTemplate(respuesta.TemplateDocumentoCertificado);
        setTemplateEtiqueta(respuesta.TemplateEtiqueta);
        setTemplateEtiquetaDetalles(respuesta.templateEtiquetaDetalles);
        setSidebarVisible(false);
        setLoader(false);
        toast.current?.show({
          severity: "success",
          summary: "Actualizado",
          detail: "Templates actualizados exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al actualizar los templates",
          sticky: true
        });
        setLoader(false);
      }
    );
  }

  const formConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "templateDocumentoId",
            tipoitemformularioid: 5,
            etiqueta: "Template de certificado",
            opciones: "admin/template?dropdown=true",
            sinOpcionInicial: true,
            opcionVacia: true,
            respuesta: template?.id
          },
          {
            nombre: "templateEtiquetaId",
            tipoitemformularioid: 5,
            etiqueta: "Template de etiqueta",
            opciones: "admin/template?dropdown=true",
            sinOpcionInicial: true,
            opcionVacia: true,
            respuesta: templateEtiqueta?.id
          },
          {
            nombre: "templateEtiquetaDetallesId",
            tipoitemformularioid: 5,
            etiqueta: "Template de etiqueta de detalles",
            opciones: "admin/template?dropdown=true",
            sinOpcionInicial: true,
            opcionVacia: true,
            respuesta: templateEtiquetaDetalles?.id
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Guardar", callback: guardarTemplates, validar: true }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Card>
        <Titulo
          botones={
            <Boton icono negro callback={abrirSidebar}>
              <i className="pi pi-pencil" />
            </Boton>
          }
        >
          Templates
        </Titulo>
        <div className="grid">
          <CampoInformacion nombreCampo="Template de certificado">
            {template?.nombre || "-"}
          </CampoInformacion>
          <CampoInformacion nombreCampo="Template de etiqueta">
            {templateEtiqueta?.nombre || "-"}
          </CampoInformacion>
          <CampoInformacion nombreCampo="Template de etiqueta de detalles">
            {templateEtiquetaDetalles?.nombre || "-"}
          </CampoInformacion>
        </div>
      </Card>

      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Editar templates</Titulo>
        <Formulario config={formConfig} loader={loader} key={formKey} />
      </Sidebar>
    </>
  );
}
